import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import '../style.css';

function About() {
  const [content, setContent] = useState('Loading...');
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch('https://raw.githubusercontent.com/ubaidbutt/my-blogs/main/pages/about.md');
        
        if (!response.ok) {
          throw new Error('Failed to fetch content');
        }
        
        const text = await response.text();
        setContent(text);
      } catch (err) {
        setError('Failed to load content. Please try again later.');
        console.error('Error fetching markdown:', err);
      }
    };

    fetchContent();
  }, []);

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="page-wrapper">
      <div className="about-container">
        <div style={{ 
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '1rem',
          margin: '2rem auto',  // Changed to auto for horizontal centering
          maxWidth: '500px',    // Reduced from 800px to 500px
          width: '100%'
        }}>
          {[...Array(4)].map((_, index) => (
            <img 
              key={index}
              src={`https://raw.githubusercontent.com/ubaidbutt/my-blogs/main/images/profile-image${index + 1}.jpeg`}
              alt={`Profile Image ${index + 1}`}
              style={{
                width: '100%',
                aspectRatio: '1/1',
                objectFit: 'cover'
              }}
            />
          ))}
        </div>
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
    </div>
  );
}

export default About;
